import React,{Component} from 'react';
import './App.css';
import Navigation from './components/Navigation/Navigation.js';
import Logo from './components/Logo/Logo.js';
import 'tachyons';
import ImageLinkForm from './components/ImageLinkForm/ImageLinkForm.js';
import Rank from './components/Rank/Rank.js';
import FaceRecognition from './components/FaceRecognition/FaceRecognition';
import Signin from './components/Signin/Signin.js';
import Register from './components/Register/Register.js';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
// import Clarifai from 'clarifai';

// const app = new Clarifai.App({
// 	apiKey:'2917e6a6e70a41ec9b9ab7e66a3c5498'
// });


//Uncaught (in promise) TypeError: Object(...) is not a function
  //  at Object.particlesInit [as init] (App.js:99:1)
//----------Particle.js code-------------------
const particlesOptions={
  "particles": {
    "number": {
      "value": 104,
      "density": {
        "enable": true,
        "value_area": 800
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "circle",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
      "image": {
        "src": "img/github.svg",
        "width": 100,
        "height": 100
      }
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 3,
      "random": true,
      "anim": {
        "enable": false,
        "speed": 40,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": true,
      "distance": 150,
      "color": "#ffffff",
      "opacity": 0.4,
      "width": 1
    },
    "move": {
      "enable": true,
      "speed": 1,
      "direction": "none",
      "random": false,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": false,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": true,
        "mode": "repulse"
      },
      "onclick": {
        "enable": true,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 400,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 400,
        "size": 40,
        "duration": 2,
        "opacity": 8,
        "speed": 3
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
}
const particlesInit =  async(main) => {
		//console.log(main);
		await loadFull(main);
	};

const particlesLoaded = (container) => {
		//console.log(container);
	};
//----------------code-end----------------
const initialState={ 
      input:'',
        imageUrl: '',
      box: {},
      route:'signin',
      isSignedIn:false,
      user:{
        id:'',
         name:'',
          email:'',
    
    entries:0,
    joined:''
      }
  }
class App extends Component {
	constructor(){
		super();
		this.state=initialState;
} 
//Unhandled Rejection (TypeError): this.props.loadUser is not a function
//this error will come as loadUser is never passed in Register
loadUser=(data)=>{
  this.setState({user:{
        id:data.id,
       name:data.name,
       email:data.email,
       entries:data.entries,
        joined:data.joined
  }
  })}

// componentDidMount(){
//   fetch('http://localhost:3000').then(response=>response.json())
//   .then(data=>console.log(data))
// }


onInputChange=(event)=>{
   this.setState({input: event.target.value});
}

calculateFaceLocation=(data)=>{
	const clarifaiFace=data.outputs[0].data.regions[0].region_info.bounding_box;
    const image=document.getElementById('inputimage');
    const width=Number(image.width);
    const height=Number(image.height);
    return{
        leftCol:clarifaiFace.left_col*width,
        topRow:clarifaiFace.top_row*height,
        rightCol:width-(clarifaiFace.right_col*width),
        bottomRow:height-(clarifaiFace.bottom_row*height)

    }
}




displayFaceBox=(box)=>{
	console.log(box);
	this.setState({box:box});
}


onButtonSubmit = () => {
this.setState({imageUrl:this.state.input});
	// app.models
	// .predict(
	// 	Clarifai.FACE_DETECT_MODEL,
	//    this.state.input
	//    //if your write this.state.imageUrl you will get error
	// )
  fetch('https://frozen-brushlands-25146.herokuapp.com/imageurl',{
         method:'post',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        input:this.state.input
      })//-- updating count of entries as user insert photos
      })
  .then(response=>response.json())
	.then( response => {
    if(response){
      fetch('https://frozen-brushlands-25146.herokuapp.com/image',{
         method:'put',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        id:this.state.user. id
      })//-- updating count of entries as user insert photos
      })
      .then(response=>response.json())
      // count=>{
      //   this.setState({user:{
      //     entries:count
      //   }})
      // } the name of user and cout was coming undefined as this.setState changes the entire user obj
      //we need to make sure that user is stil the same while we are changing the count
      // In onject.assign we get the target object and second is what we want to extend it Object.assign(target, source);
      .then(count=>{Object.assign(this.state.user,{entries:count})})
      .catch(console.log)
    }
    this.displayFaceBox(this.calculateFaceLocation(response))})
		.catch(err=>console.log(err));

}
onRouteChange=(route)=>{
	if(route==='signout'){
		this.setState(initialState)
	}else if(route==='home'){
		this.setState({isSignedIn:true})
	}
	this.setState({route:route});
}



 render(){
 const	{isSignedIn,imageUrl,route,box} = this.state;
	return (
		<div className="App">
	         <Particles id="tsparticles" init={particlesInit} loaded={particlesLoaded}
	          options={particlesOptions} />
			 <Navigation isSignedIn={this.state.isSignedIn} onRouteChange={this.onRouteChange}/>
			 {this.state.route==='home'
				 ?<div>
				   <Logo / >
		           <Rank name={this.state.user.name} entries={this.state.user.entries}/>
		           <ImageLinkForm onInputChange={this.onInputChange} 
		             onButtonSubmit={this.onButtonSubmit}/>
		           <FaceRecognition box={this.state.box}imageUrl={this.state.imageUrl} />
		         </div>
		         :(
		           this.state.route==='signin'
		           ?<Signin loadUser={this.loadUser} onRouteChange={this.onRouteChange}/>
		           :<Register loadUser={this.loadUser} onRouteChange={this.onRouteChange}/>
		           ) 
	            }
        </div>
    );
}
}
export default App;
